module.exports = __webpack_public_path__ + "img/shape-2.587cc08e.png";